// extracted by mini-css-extract-plugin
export default {"para":"styles_para__TUEDd","Wrapper":"styles_Wrapper__rfOHh","Main":"styles_Main__6TFHw"};